module.exports = __webpack_public_path__ + "favicon/favicon_150.918ee2e5.png";